module.exports = __webpack_public_path__ + "img/clock.47e499ae.svg";